import * as tslib_1 from "tslib";
/**
 * Service versions. Only if they are differnt
 */
import { environment } from './../../../../environments/environment';
export var serviceVersion = new Map([
    ['authenticateUser', '10.0'],
    ['authenticateCookie', '10.0'],
    ['authenticateToken', '10.0'],
    ['getOrderDetails', '1.0'],
    ['publishmemberevents', '1.0'],
    ['webContent', '2.0'],
    ['refreshToken', '3.0'],
    ['prefetchRxStatusSummary', '3.0'],
    ['logoutUser', 'v1'],
    ['manageOrder', '1.0'],
    ['getRxHistory', '1.0'],
    ['getSDEligibility', '1.0.0'],
    ['memberEvents', '1.0']
]);
/**
 * Service api roots. Only if they are differnt
 */
export var serviceApiRoots = new Map([
    ['getOrderDetails', '/Services/ICEAGPV1/mdp/1.0.0/'],
    ['authenticateUser', '/Services/icet/loginUser/10.0/'],
    ['authenticateCookie', '/Services/icet/loginUser/10.0/'],
    ['loginCookies', '/Services/icet/loginUser/10.0/'],
    ['authenticateToken', 'Services/icet/loginUser/10.0/'],
    ['refreshToken', '/Services/icet/tokens/3.0/'],
    ['logoutUser', '/Services/icet/ProfileService/v1/'],
    ['publishmemberevents', 'https://services' + (environment.sit || environment.local ? '-sit2' : '')
            + '.cvs.com/RETAGPV1/memberevents/1.0.0/'],
    ['webContent', 'https://' + (environment.sit || environment.local ? 'sit2' : '')
            + 'depservices.cvs.com/proxy/genericService'],
    ['prefetchRxSummary', 'Services/icet/prefetch/3.0/'],
    ['manageOrder', '/Services/ICEAGPV1/multidosepack/1.0.0/'],
    ['getRxHistory', '/Services/ICEAGPV1/mdp/'],
    ['getSDEligibility', '/Services/ICEAGPV1/pricingengine/1.0.0/'],
    ['memberEvents', 'https://' + (environment.sit || environment.local ? 'sit2' : '')
            + 'depservices.cvs.com/DEP/'],
    ['getXIDDetails', '/Services/ICEAGPV1/mdp/1.0.0/'],
    ['getBccContent', '/Services/ICEAGPV1/Content/V1/'],
    ['profileMaintenance', '/Services/ICEAGPV1/profile/1.0.0/']
]);
export var channel = {
    RETAIL_ANDRIOD_APP: 'CVS_RETAIL_ANDROID',
    RETAIL_IOS_APP: 'CVS_RETAIL_IPHONE'
};
export var rememberMeCookieDetails = {
    rememberMeCookieName: 'ICE_REMEMBER_v1',
    rememberMeCookieAge: 60
};
export var idleConfig = {
    idleDuration: 4 * 60,
    timeoutDuration: 5 * 60
};
export var statusTranslation = {
    'MDP_ORDER_SUBMITTED': 'Preparing to ship',
    'MDP_ORDER_PRINTED': 'Preparing to ship',
    'MDP_ORDER_COMPLETED': 'Shipped',
    'MDP_ORDER_PICKEDUP': 'Shipped',
    'MDP_ORDER_APPROVAL_REQUIRED': 'Approval required',
    'MDP_ORDER_APPROVAL_PAST_DUE': 'Approval required',
    'MDP_ORDER_APPROVED': 'In process',
    'MDP_SYNCPLAN_APPROVED': 'In process',
    'MDP_ORDER_AUTOFILL_REVIEW': 'In process'
};
export var statusTranslationClass = {
    'MDP_ORDER_APPROVAL_REQUIRED': 'plain',
    'MDP_ORDER_APPROVAL_PAST_DUE': 'danger',
    'MDP_ORDER_SUBMITTED': 'box-with-stripe',
    'MDP_ORDER_PRINTED': 'box-with-stripe',
    'MDP_ORDER_APPROVED': 'house',
    'MDP_ORDER_COMPLETED': 'box-with-stripe',
    'MDP_ORDER_PICKEDUP': 'box-with-stripe',
    'MDP_ORDER_AUTOFILL_REVIEW': 'house'
};
export var statusTranslationSubtitles = {
    'MDP_SYNCPLAN_APPROVED': 'Here\'s how we\'ll provide your medications.',
    'MDP_ORDER_SUBMITTED': 'Your order is being prepared',
    'MDP_ORDER_PRINTED': 'Your order is being prepared',
    'MDP_ORDER_APPROVAL_REQUIRED': 'Approval required ',
    'MDP_ORDER_APPROVAL_PAST_DUE': 'Approval required ',
    'MDP_ORDER_APPROVED': 'We are reviewing your order',
    'MDP_ORDER_AUTOFILL_REVIEW': 'Welcome back'
};
export var statusTranslationLabels = {
    'MDP_ORDER_SUBMITTED': 'Shipping by',
    'MDP_ORDER_PRINTED': 'Shipping by',
    'MDP_ORDER_COMPLETED': 'Arriving by',
    'MDP_ORDER_PICKEDUP': 'Arriving by',
    'MDP_ORDER_APPROVAL_REQUIRED': 'Approve by',
    'MDP_ORDER_APPROVAL_PAST_DUE': 'Approve by',
    'MDP_ORDER_APPROVED': 'Shipping by',
    'MDP_SYNCPLAN_APPROVED': 'Shipping by',
    'MDP_ORDER_AUTOFILL_REVIEW': 'Shipping by'
};
export var rewordDictionary = {
    'Your order is being prepared': 'Your order is being prepared to ship',
    'Arriving by': 'Your order should arrive by',
    'Arrived by': 'Your order arrived by'
};
export var rootUrl = 'https://www' + ((environment.sit || environment.local) ? ('-' + environment.currentEnvStack).toLowerCase() : '') + '.cvs.com';
export var originDomain = window.location.origin;
export var externalUrls = {
    iceV1Url: rootUrl + '/pharmacy/v1/',
    rootUrl: rootUrl,
    origin: originDomain
};
export var timeOutModalContents = {
    IDLE_TIME: {
        title: 'Are You Still There?',
        body: '<p>Your session will automatically time out in 5 minutes due to inactivity.</p>',
        primaryAction: 'I\'m Here',
    },
    TIMED_OUT: {
        title: 'Your Session Has Timed Out ',
        body: '<p> We\'ve signed you out of your account to help protect your prescription information. '
            + 'Any action (such as a refill request) that wasn\'t confirmed has been lost.Please sign back'
            + ' in on the dashboard to resume your activity.</p>'
            + '<p> If your session is complete, quit your browser for added security.</p>',
        primaryAction: 'Return to Dashboard'
    },
    SIGNED_OUT: {
        title: 'You Are Now Signed Out',
        body: 'To protect your privacy, don\'t forget to sign out every time you finish your CVS.com session\n' +
            'To further protect your personal information, we recommend you also quit your browser',
        primaryAction: 'Close'
    }
};
export var approvalMsg = {
    type: 'success',
    title: 'Your approval request is submitted.',
    msg: 'We are reviewing your order',
    focusOn: true,
    roleAlert: true
};
export var approvalMsgWithAutoFill = {
    type: 'success-banner',
    title: 'Thanks for approving. Would you like to skip this step from now on?',
    msg: "We can automatically refill your SimpleDose&trade; packs, so you won't have to approve your order every month.\nYou can turn this feature off at any time.",
    withNgContent: true,
    focusOn: true,
    roleAlert: false
};
export var autofillEnrollEnableSuccess = {
    type: 'success-banner',
    title: 'Auto refill is now activated',
    msg: "Your next SimpleDose&trade; pack will be filled automatically, without the need for any additional approval on your end.",
    focusOn: false,
    withNgContent: false,
    roleAlert: false
};
export var autofillEnrollDisableSuccess = {
    type: 'success-banner',
    title: 'Auto refill has been turned off',
    msg: "We will stop refilling your SimpleDose&trade; packs automatically.",
    focusOn: false,
    withNgContent: false,
    roleAlert: false
};
export var autofillEnrollFailure = {
    type: 'fail-banner',
    title: 'There\'s a problem with our system',
    msg: "<div class=\"one-line\">\n          <p aria-hidden=\"true\">We can't process your request at this time. Please call </p>\n          <a href=\"tel:1-800-753-0596\" role=\"link\" aria-label=\"We can't process your request at this time.\n          Please call 1-800-753-0596 so we can assist you. We're sorry for the inconvenience.\"\n             class=\"bold\"> 1-800-753-0596 </a>\n          <p aria-hidden=\"true\"> so we can assist you. We're sorry for the inconvenience.</p>\n        </div>",
    focusOn: false,
    roleAlert: false
};
export var reviewFailure = tslib_1.__assign({}, autofillEnrollFailure, { roleAlert: true });
export var failureMsg = {
    type: 'danger',
    title: 'Your request can\'t be processed right now',
    msg: "<div class=\"one-line\">\n          <p aria-hidden=\"true\">Try again later or call </p>\n          <a href=\"tel:1-800-753-0596\" role=\"link\" aria-label=\"Try again later or call 18007530596 to approve or update your order.\"\n             class=\"bold\"> 1-800-753-0596 </a>\n          <p aria-hidden=\"true\"> to approve or update your order.</p>\n        </div>",
    focusOn: true,
    roleAlert: true
};
export var viewConfig = new Map([
    ['/autofill', {
            heading: false,
            tabs: false,
            greeting: false,
            footer: true,
            cssClass: 'gradient'
        }]
]);
export var updatedOrderMsg = {
    type: 'success-banner',
    title: 'Thanks for updating Your order',
    msg: 'We will take it from here.',
    focusOn: true
};
export var selectAccountFailure = {
    type: 'fail-banner',
    title: 'Select the person you\'d like to switch to.',
    msg: 'Make a selection',
    focusOn: true,
    roleAlert: true
};
export var reconsentFailure = {
    type: 'fail-banner',
    title: 'Let us know if you\'d like to use auto refill',
    msg: 'Make a selection',
    focusOn: false,
    roleAlert: true
};
export var autofillIneligible = {
    type: 'ineligible-banner',
    title: 'You\'ve added 1 or more manual refill medications. You\'ll need to approve this order each month. ',
    msg: 'To keep auto refill, remove any manual refill medications from your order. You can still get them from CVS Pharmacy®.',
    focusOn: true,
    roleAlert: true
};
/*
A list of services' names or  json file name, that spinner service wiill ignore in interceptor
 */
export var silentServices = ['refreshToken', 'prefetchRxStatusSummary', 'webContent', 'getBccContent', 'memberEvents',
    'getXIDDetails', '34700.json', '34701.json', '37220.json', '41002.json', '38307.json'];
